/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PresentationRevokeBySubjectParams { 
    /**
     * Presentation unique identifier.
     */
    idHash: string;
    /**
     * Revoke subject presentation transaction signed by the subject. This transaction must call the smart contract revocation method indicating which credentialHash wants to revoke for the identity. Encoded in Base64 format
     */
    revokeSubjectPresentationTransactionSigned?: PresentationRevokeBySubjectParams.RevokeSubjectPresentationTransactionSignedEnum;
}
export namespace PresentationRevokeBySubjectParams {
    export const RevokeSubjectPresentationTransactionSignedEnum = {
        B6428591a: '[B@6428591a'
    } as const;
    export type RevokeSubjectPresentationTransactionSignedEnum = typeof RevokeSubjectPresentationTransactionSignedEnum[keyof typeof RevokeSubjectPresentationTransactionSignedEnum];
}


